import React, { useContext } from 'react'; // eslint-disable-line
import universal from '@core-ui/universal';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';
import { useLocalize } from '@core-ui/localization-provider';
import { ClearButtonProps } from '@core-ui/clear-button';
import { QuickFilterProps, Option, SizeOption } from '@cat/quick-filter/types';
import useQuickFilter from '../../hooks/features/useQuickFilter';
import { CLEAR_FILTER_BUTTON } from './localization-tokens';
import ClearButtonWrapper from './styled/ClearButtonWrapper';
import { QuickFilterWrapperProps } from './types';
import { prepareAllowedFacetsAsPerBrand } from './collaborators/quick-filter-allowed-facets';
import ABSegmentContext from '../ab-segment-context';

const QuickFilterPlaceholder = universal(import('../quick-filter-placeholder'));

const QuickFilter = universal<QuickFilterProps>(import('@cat/quick-filter'), {
  key: 'default',
  loading: <QuickFilterPlaceholder />,
});

const ClearButton = universal<ClearButtonProps>(
  import('@core-ui/clear-button'),
  {
    key: 'ClearButton',
  }
);

const QuickFilterWrapper = (
  props: QuickFilterWrapperProps
): JSX.Element | null => {
  const {
    facetOptions,
    abbrBrand,
    publish,
    appliedOptions,
    mediator,
    appliedFacets,
  } = props;

  const isQuickFilterEnabled = useQuickFilter();
  const segments = useContext(ABSegmentContext);
  const ABsegValue = segments[`${abbrBrand}112`];
  const { localize } = useLocalize();
  const { smallerThan } = useContext(BreakpointContext);
  const isMobile = smallerThan(XLARGE);

  const getClearButton = (appliedOptions: (Option | SizeOption)[]) =>
    isMobile && appliedOptions.length > 0 ? (
      <ClearButtonWrapper>
        <ClearButton
          localizedButtonText={localize(CLEAR_FILTER_BUTTON)}
          mediator={mediator}
        />
      </ClearButtonWrapper>
    ) : null;

  if (!isQuickFilterEnabled) {
    return null;
  }
  return facetOptions?.length ? (
    <>
      <QuickFilter
        appliedOptions={appliedOptions}
        facets={facetOptions}
        mediator={mediator}
        key="quick-filters"
        onFacetChange={(option) => publish('updateFacets', [option])}
        appliedFacets={appliedFacets}
        allowedFacets={prepareAllowedFacetsAsPerBrand(abbrBrand, ABsegValue)}
      />
      {getClearButton(appliedOptions)}
    </>
  ) : (
    <QuickFilterPlaceholder key="quick-filter-placeholder" />
  );
};

export default QuickFilterWrapper;
